import { of } from "rxjs";
import { catchError, filter, map, mergeMap } from "rxjs/operators";
import { LOCATION_CHANGE } from "connected-react-router";

import { addMessage } from "../../../../../redux/actions/messagesActions";
import { Effect } from "../../../../../redux/types/effect.type";
import { EffectActionsObservable } from "../../../../../redux/types/effect-actions-observable.type";
import { isActionType } from "../../../../../redux/action.functions";

import * as productService from "../services/campaign-brief-products.service";

import * as actions from "./campaign-brief-products.actions";
import { CampaignBriefProductsActions } from "./campaign-brief-products.actions";

const addProduct: Effect = (action$: EffectActionsObservable) =>
  action$.pipe(
    filter(isActionType(CampaignBriefProductsActions.AddProduct)),
    map((action) => action.payload),
    mergeMap(({ product, CampaignBriefId }) =>
      productService.addProduct(product, CampaignBriefId).pipe(
        map((product) => actions.addProductSuccess(product)),
        catchError((error) => of(actions.addProductFailure(error)))
      )
    )
  );

const fetchProducts: Effect = (action$: EffectActionsObservable) =>
  action$.pipe(
    filter(isActionType(CampaignBriefProductsActions.FetchProducts)),
    map((action) => action.payload),
    mergeMap(({ CampaignBriefId }) =>
      productService.fetchProducts(CampaignBriefId).pipe(
        map(({ results }) => actions.fetchProductsSuccess(results)),
        catchError((error) => of(actions.fetchProductsFailure(error)))
      )
    )
  );

const reset: Effect = (action$: EffectActionsObservable) =>
  action$.pipe(
    filter((action) => action.type === LOCATION_CHANGE),
    map(() => actions.reset())
  );

const updateProducts: Effect = (action$: EffectActionsObservable) =>
  action$.pipe(
    filter(isActionType(CampaignBriefProductsActions.UpdateProducts)),
    map((action) => action.payload),
    mergeMap(({ products, CampaignBriefId }) =>
      productService.updateProducts(products, CampaignBriefId).pipe(
        map(({ products }) => actions.updateProductsSuccess(products)),
        catchError((error) => of(actions.updateProductsFailure(error)))
      )
    )
  );

const updateProductsSuccess: Effect = (action$: EffectActionsObservable) =>
  action$.pipe(
    filter(isActionType(CampaignBriefProductsActions.UpdateProductsSuccess)),
    map(() => addMessage({ text: "Products saved successfully.", severity: "success" }))
  );

export const CampaignBriefProductsEffects = [
  addProduct,
  fetchProducts,
  reset,
  updateProducts,
  updateProductsSuccess,
];
